class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.sections = this.getElementsByClassName('product-page--accordion');
    this.registerSections();
  }

  registerSections() {
    for (var i = 0; i < this.sections.length; i++) {
      this.sections[i].addEventListener('click', function () {
        this.classList.toggle('active');
      });
    }
  }
}

customElements.define('product-accordion', ProductAccordion);
